module.exports = __webpack_public_path__ + "img/9.d44b60c2.jpg";